import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { ProductResource } from '@df/catalog/product/product.resource';
import compact from 'lodash-es/compact';
import { NBloomreach } from './bloomreach.namespace';
import { BloomreachService } from './bloomreach.service';

@Injectable({
    providedIn: 'root'
})
export class BloomreachRecommendationsEngine {
    protected bloomreachService = inject(BloomreachService);
    protected productResource = inject(ProductResource);

    get(
        sourceIds: number[],
        cb: IRelatedProductsCallback,
        engineOptions: NBloomreach.IRecommendationsEngineOptions,
        options: IRelatedProductsOptions
    ) {
        if (engineOptions.options) {
            const skus = compact(sourceIds?.map(i => this.productResource.get(i)?.data?.sku) || []);
            this.bloomreachService
                .loadRecommendationsProductIds(engineOptions.options, skus)
                .then(cb)
                .catch(() => {
                    cb([]);
                });
        } else {
            cb([]);
        }
    }
}

RelatedProductsService.registerEngine(NBloomreach.RECOMMENDATIONS_ENGINE_ID, BloomreachRecommendationsEngine);
